import { useMutation } from "react-query";
import { uploadLeasedEquipment } from "actions/CarrierAgreementMgmt/LeasedEquipment";

const useUploadMassUploadFile = () => {
  return useMutation(uploadLeasedEquipment);
};

export default useUploadMassUploadFile;

//add
